import { useAppSelector } from "@/store/hooks";
import { useMemo } from "react";

const useAuth = () => {
  const { user, current_subscription } = useAppSelector((state) => state.auth);

  const [hasHotelAccess, hasRestaurantAccess, hasBothHotelRestaurant, hasHotelBilling] = useMemo(() => {
    if (!user) return [false, false, false, false];
    // A combined "hotel + restaurant" plan grants BOTH — mirror acl.tsx so the sidebar nav matches
    // route access (otherwise a Hotel-Plus-Dining / Hospitality-Pro business sees no restaurant menu).
    const both = !!current_subscription?.hotel_restaurant_service;
    return [
      !!current_subscription?.hotel_service || both,
      !!current_subscription?.restaurant_service || both,
      both,
      !!current_subscription?.hotel_billing_service,
    ];
  }, [user, current_subscription]);

  const [isSuperAdmin, isBusinessOwner] = useMemo(() => {
    if (!user) return [false, false];
    return [user.is_default, user.is_owner || user.is_main_business];
  }, [user]);

  return {
    hasHotelAccess,
    hasRestaurantAccess,
    isSuperAdmin,
    isBusinessOwner,
    hasBothHotelRestaurant,
    hasHotelBilling,
  };
};

export default useAuth;
